import { ProductionPlan } from "models/ProductionPlan";
import { SearchPeriodProductionPlan } from "src/store/api/generatedApi";

export const convertSearchPeriodProductionPlan = (
  productionPlan: SearchPeriodProductionPlan
): ProductionPlan =>
  (productionPlan.steel_grade_items ?? []).length > 0
    ? { type: "steelGrade", items: productionPlan.steel_grade_items ?? [] }
    : (productionPlan.product_group_items ?? []).some(
          (item) => item.num_heats > 0
        )
      ? {
          type: "productGroup",
          items: productionPlan.product_group_items ?? [],
        }
      : { type: "empty", items: [] };
